/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */
/* eslint-disable new-cap */
import moment from 'moment';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import {
  numGradeToEUgradeEW,
  formatedSkillStatus,
  FormatDate,
  levelToCEFR,
  calculateIndice,
} from '../../../../helpers/utils';
import img from '../../../../shared/img/logo/logo.png';
import footer from '../../../../shared/img/footer.png';

const generatePDF = (courseInfos, report, student, grade, contentTitles, specificSkills, t, language) => {
  const bodyObjectives = [];
  if (courseInfos.objectives !== undefined) {
    courseInfos.objectives.forEach((objective) => {
      bodyObjectives.push([objective.name]);
    });
  }

  const items = [
    { title: t('pdf.endReport.trainee', 'Stagiaire'), body: `${student.name} ${student.firstname}` },
    { title: t('pdf.endReport.entity', 'Entité'), body: courseInfos.company.name },
    { title: t('pdf.endReport.trainingName', 'Intitulé de la formation'), body: courseInfos.name },
    {
      title: t('pdf.endReport.courseLanguageAndLevel', 'Langue et niveau du cours'),
      body: (courseInfos.level || courseInfos.level === 0) && courseInfos.language
        ? `${courseInfos.language.name} - ${levelToCEFR(courseInfos.level)}`
        : 'n/a',
    },
    {
      title: t('pdf.endReport.teacher', 'Formateur'),
      body: Array.isArray(courseInfos.idTeachers) && courseInfos.idTeachers.length > 0
        ? courseInfos.idTeachers.map((tt) => `${tt.name} ${tt.firstname}`).join(', ')
        : 'n/a',
    },
    { title: t('pdf.endReport.duration', 'Durée'), body: `${courseInfos.coursePlan.duration}h` },
    { title: t('pdf.endReport.startDate', 'Date de début'), body: moment(courseInfos.coursePlan.beginDate).format('DD/MM/YYYY') },
    { title: t('pdf.endReport.endDate', 'Date de fin'), body: moment(courseInfos.coursePlan.endDate).format('DD/MM/YYYY') },
    {
      title: t('pdf.endReport.progressIndex', 'Indice de progression'),
      body: calculateIndice(
        grade.global,
        report.endlevel.global,
        (report.presenceSummary.missing + report.presenceSummary.justified + report.presenceSummary.present),
      ),
    },
    {
      title: t('pdf.endReport.presences', 'Présences'),
      body: report.presenceSummary ? `${report.presenceSummary.present}h/${courseInfos.coursePlan.duration}h` : 'n/a',
    },
    {
      title: t('pdf.endReport.absences', 'Absences'),
      body: report.presenceSummary ? `${report.presenceSummary.missing}h/${courseInfos.coursePlan.duration}h` : 'n/a',
    },
    {
      title: t('pdf.endReport.justifiedAbsences', 'Absences justifiées'),
      body: report.presenceSummary ? `${report.presenceSummary.justified}h/${courseInfos.coursePlan.duration}h` : 'n/a',
    },
  ];

  // formatting skills rows for autoTable
  const bodySkills = [];

  if (contentTitles !== undefined) {
    contentTitles.forEach((contentTitle) => {
      bodySkills.push([{ content: language === 'en' ? contentTitle.EN : contentTitle.FR, colSpan: 7 }]);
      contentTitle.content.forEach((skill) => {
        if (skill.categories?.includes('vocPro') && courseInfos.coursePlan?.vocPro) {
          skill.categoriesVoc = courseInfos.coursePlan.vocPro;
        }
        if (skill.categories?.includes('vocInterests') && courseInfos.coursePlan?.vocInterests) {
          skill.categoriesVoc = courseInfos.coursePlan.vocInterests;
        }
        if (skill.categories?.includes('vocWork') && courseInfos.coursePlan?.vocWork) {
          skill.categoriesVoc = courseInfos.coursePlan.vocWork;
        }
        let label = language === 'en' ? skill.EN : skill.FR;
        if (skill.categoriesVoc) {
          let categories = label;
          skill.categoriesVoc.forEach((elem, indexSkill) => {
            if (indexSkill === skill.categoriesVoc.length - 1) categories += ` ${elem}.`;
            else categories += ` ${elem},`;
          });
          label = categories;
        }

        const defaultTeacher = Array.isArray(courseInfos.idTeachers) && courseInfos.idTeachers.length > 0
          ? `${courseInfos.idTeachers[0].name} ${courseInfos.idTeachers[0].firstname}`
          : 'n/a';

        const skillObj = {
          description: label,
          status: formatedSkillStatus(3),
          date: FormatDate(Date.now()),
          teacher: defaultTeacher,
        };

        report.followup?.forEach((skillFollowUp) => {
          if (skillFollowUp.skill === skill._id) {
            skillObj.status = formatedSkillStatus(skillFollowUp.status);
            skillObj.date = FormatDate(skillFollowUp.date);
          }
        });

        bodySkills.push([
          skillObj.description,
          ...skillObj.status,
          skillObj.date,
          skillObj.teacher,
        ]);
      });
    });
  }

  // formatting specific skills rows for autoTable
  if (specificSkills && specificSkills.length > 0) {
    bodySkills.push([{ content: t('pdf.endReport.specificSkills', 'Compétences spécifiques'), colSpan: 7 }]);
    specificSkills.forEach((skill) => {
      const defaultTeacher = Array.isArray(courseInfos.idTeachers) && courseInfos.idTeachers.length > 0
        ? `${courseInfos.idTeachers[0].name} ${courseInfos.idTeachers[0].firstname}`
        : 'n/a';

      const skillObj = {
        description: language === 'en' ? skill.EN : skill.FR,
        status: formatedSkillStatus(3),
        date: FormatDate(Date.now()),
        teacher: defaultTeacher,
      };

      report.followup?.forEach((skillFollowUp) => {
        if (skillFollowUp.skill === skill._id) {
          skillObj.status = formatedSkillStatus(skillFollowUp.status);
          skillObj.date = FormatDate(skillFollowUp.date);
        }
      });

      bodySkills.push([
        skillObj.description,
        ...skillObj.status,
        skillObj.date,
        skillObj.teacher,
      ]);
    });
  }

  // Creating doc
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'px',
    format: 'letter',
  });

  doc.addImage(img, 'PNG', 210, 20, 45, 30);

  doc
    .setFontSize(12)
    .text(
      t('pdf.endReport.title', 'Bilan de fin de formation'),
      doc.internal.pageSize.getWidth() / 2,
      70,
      { align: 'center' },
    );

  doc
    .setFontSize(12)
    .text(
      t(
        'pdf.endReport.subtitle',
        '{{last}} {{first}} de la société {{company}}',
        {
          last: student?.name || 'n/a',
          first: student?.firstname || 'n/a',
          company: courseInfos?.company?.name || 'n/a',
        },
      ),
      doc.internal.pageSize.getWidth() / 2,
      85,
      { align: 'center' },
    );

  doc.setLineWidth(0.1).line(20, 95, 430, 95);

  autoTable(doc, {
    body: items,
    margin: { left: 20, top: 105 },
    styles: { fontSize: 7 },
    columnStyles: { 0: { fontStyle: 'bold' } },
    rowPageBreak: 'avoid',
  });

  autoTable(doc, {
    head: [[t('pdf.endReport.objectives', 'Objectifs de la formation: ')]],
    body: bodyObjectives,
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 8,
    },
    styles: { fontSize: 7 },
    margin: { left: 20, top: 20 },
    rowPageBreak: 'avoid',
  });

  autoTable(doc, {
    head: [
      [{ content: t('pdf.endReport.levelsBlock', 'Niveaux'), colSpan: 8 }],
      [
        { content: t('pdf.endReport.levels', 'Niveaux'), rowSpan: 2 },
        { content: t('pdf.endReport.speaking', 'Expression orale'), colSpan: 2 },
        { content: t('pdf.endReport.listening', 'Compréhension orale'), rowSpan: 2 },
        { content: t('pdf.endReport.writing', 'Expression écrite'), rowSpan: 2 },
        { content: t('pdf.endReport.reading', 'Compréhension écrite'), rowSpan: 2 },
        { content: t('pdf.endReport.globalLevel', 'Niveau global'), colSpan: 2 },
      ],
    ],
    body: [
      [
        '',
        t('pdf.endReport.fluency', 'Fluidité'),
        t('pdf.endReport.accuracy', 'Précision'),
        '',
        '',
        '',
        t('pdf.endReport.ewi', 'EWI'),
        t('pdf.endReport.cefrStar', 'CEFR*'),
      ],
      [
        t('pdf.endReport.startOfTraining', 'Début de la formation'),
        grade && grade.oralFluency ? grade.oralFluency : '',
        grade && grade.oralAccuracy ? grade.oralAccuracy : '',
        grade && grade.listeningComprehension ? grade.listeningComprehension : '',
        grade && grade.writing ? grade.writing : '',
        grade && grade.readingComprehension ? grade.readingComprehension : '',
        grade && grade.global ? grade.global : '',
        grade && grade.global ? numGradeToEUgradeEW(parseFloat(grade.global)) : t('pdf.endReport.beginner', 'Débutant'),
      ],
      [
        t('pdf.endReport.endOfTraining', 'Fin de la formation'),
        report.endlevel && report.endlevel.oralFluency ? report.endlevel.oralFluency : '',
        report.endlevel && report.endlevel.oralAccuracy ? report.endlevel.oralAccuracy : '',
        report.endlevel && report.endlevel.listeningComprehension ? report.endlevel.listeningComprehension : '',
        report.endlevel && report.endlevel.writing ? report.endlevel.writing : '',
        report.endlevel && report.endlevel.readingComprehension ? report.endlevel.readingComprehension : '',
        report.endlevel && report.endlevel.global ? report.endlevel.global : '',
        report.endlevel && report.endlevel.global ? numGradeToEUgradeEW(parseFloat(report.endlevel.global)) : t('pdf.endReport.beginner', 'Débutant'),
      ],
    ],
    margin: { left: 20, top: 20 },
    styles: { fontSize: 7, valign: 'middle', halign: 'center' },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 8,
      lineWidth: 0.5,
    },
    bodyStyles: { lineWidth: 0.5 },
    theme: 'grid',
    showFoot: 'lastPage',
    rowPageBreak: 'avoid',
    didParseCell(data) {
      if (data.row.index === 0) {
        data.cell.styles.fillColor = [255, 255, 255];
      }
    },
  });

  autoTable(doc, {
    head: [
      [{ content: t('pdf.endReport.levelsInterpretation', "Tableau d'interprétation des niveaux"), colSpan: 10 }],
      [
        '',
        t('pdf.endReport.beginner', 'Débutant'),
        t('pdf.endReport.elementary', 'Elémentaire'),
        t('pdf.endReport.preIntermediate', 'Pré-intermédiaire'),
        { content: t('pdf.endReport.intermediate', 'Intermédiaire'), colSpan: 2 },
        t('pdf.endReport.advanced', 'Avancé'),
        t('pdf.endReport.independent', 'Autonome'),
        t('pdf.endReport.mastery', 'Maîtrise'),
        t('pdf.endReport.bilingual', 'Bilingue'),
      ],
    ],
    body: [
      [t('pdf.endReport.ewi', 'EWI'), '0-2', '3', '4', '5', '6', '7', '8', '9', '10'],
      [{ content: t('pdf.endReport.councilOfEuropeStar', "Conseil de l'Europe*"), rowSpan: 2 }, '', 'A1', 'A2', { content: 'B1', colSpan: 2 }, 'B2', 'C1', 'C2', ''],
      [
        t('pdf.endReport.beginner', 'Débutant'),
        { content: t('pdf.endReport.elementaryUser', 'Utilisateur élémentaire'), colSpan: 2 },
        { content: t('pdf.endReport.independentUser', 'Utilisateur indépendant'), colSpan: 3 },
        { content: t('pdf.endReport.proficientUser', 'Utilisateur expérimenté'), colSpan: 2 },
        '',
      ],
    ],
    foot: [[{ content: t('pdf.endReport.cecrFoot', '* Cadre européen commun de référence pour les langues (CECR)'), colSpan: 8 }]],
    margin: { left: 20, top: 20 },
    styles: { fontSize: 7, valign: 'middle', halign: 'center' },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 8,
      lineWidth: 0.5,
    },
    footStyles: {
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 6,
      lineWidth: 0.5,
      halign: 'left',
      fontStyle: 'normal',
    },
    rowPageBreak: 'avoid',
    bodyStyles: { lineWidth: 0.5 },
    columnStyles: { 4: { cellWidth: 30 }, 5: { cellWidth: 30 } },
    theme: 'grid',
  });

  autoTable(doc, {
    head: [[t('pdf.endReport.teacherCommentary', 'Commentaire formateur:')]],
    body: [[report.comment]],
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 8,
    },
    styles: { fontSize: 7 },
    margin: { left: 20, top: 20 },
    rowPageBreak: 'avoid',
  });

  autoTable(doc, {
    head: [[
      t('pdf.endReport.skills', 'Compétences'),
      t('pdf.endReport.notAcquired', 'Non acquis'),
      t('pdf.endReport.partiallyAcquired', 'Partiellement acquis'),
      t('pdf.endReport.acquired', 'Acquis'),
      t('pdf.endReport.notApplicable', 'Non applicable'),
      t('pdf.endReport.date', 'Date'),
      t('pdf.endReport.teacher', 'Formateur'),
    ]],
    body: bodySkills,
    margin: { left: 20, top: 20 },
    styles: { fontSize: 7, valign: 'middle' },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 8,
      lineWidth: 0.5,
    },
    columnStyles: {
      1: { halign: 'center' },
      2: { halign: 'center' },
      3: { halign: 'center' },
      4: { halign: 'center' },
    },
    bodyStyles: { lineWidth: 0.5 },
    rowPageBreak: 'avoid',
    theme: 'grid',
  });

  autoTable(doc, {
    body: [[{ content: '', colSpan: 1 }]],
    styles: {
      fontSize: 7,
      minCellWidth: 300,
      minCellHeight: 110,
      lineWidth: 0,
    },
    bodyStyles: {
      fillColor: [255, 255, 255],
      lineWidth: 0,
    },
    theme: 'grid',
    margin: { left: 20, top: 30 },
    rowPageBreak: 'avoid',
    didDrawCell(data) {
      const textPos = data.cell;
      data.cell.styles.fillColor = [255, 255, 255];
      doc.addImage(footer, textPos.x + 100, textPos.y + 5, 240, 140);
    },
  });

  doc.save(`${student.name}_${student.firstname}_report.pdf`);
};

export { generatePDF };
